import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QuizSolutionDialogData } from '../../data/dialogData/QuizSolutionDialogData';
import { QuizSolutionDialogComponent } from '../../ui/dialogs/quiz-solution-dialog/quiz-solution-dialog.component';
import { firstValueFrom } from 'rxjs';
import { CourseManagerLoginDialogComponent } from '../../ui/dialogs/course-manager-login-dialog/course-manager-login-dialog.component';
import { TextInputDialogComponent } from '../../ui/dialogs/text-input-dialog/text-input-dialog.component';
import { UploadDialogComponent } from '../../ui/dialogs/upload-dialog/upload-dialog.component';
import { ConfirmDialogComponent } from '../../ui/dialogs/confirm-dialog/confirm-dialog.component';
import { TextItemDialogComponent } from '../../ui/dialogs/text-item-dialog/text-item-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  async openQuizSolutionDialog(data: QuizSolutionDialogData, disableClose: boolean): Promise<boolean> {
    const dialogRef = this.dialog.open(QuizSolutionDialogComponent, {
      width: '400px',
      data,
      disableClose: disableClose, 
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }

  async openCourseManagerLoginDialog(): Promise<void> {
    const dialogRef = this.dialog.open(CourseManagerLoginDialogComponent, {
      width: '400px'
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }

  async openInputDialog(): Promise<string | undefined> {
    const dialogRef = this.dialog.open(TextInputDialogComponent, {
      width: '400px',
      data: {
        title: 'Neue Lektion',
        label: 'Titel der Lektion',
        value: '',
      },
    });
  
    return await firstValueFrom(dialogRef.afterClosed());
  }

  async openUploadDialog(): Promise<{ materialName: string; file: File } | null> {
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      width: '400px'
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }

  async openConfirmDialog(title: string, content: string): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title,
        content
      },
      disableClose: true,
    });
    
    return await firstValueFrom(dialogRef.afterClosed());
  }

  async openTextContentDialog(title = '', initialContent = ''): Promise<{ title: string; content: string } | null> {
    const dialogRef = this.dialog.open(TextItemDialogComponent, {
      width: '400px',
      data: {
        title,
        content: initialContent
      }
    });
  
    return await firstValueFrom(dialogRef.afterClosed());
  }
}

